import { observable, action, configure, makeObservable } from 'mobx';
import { IEdetector } from '@utils/browserUTLs';

configure({
  enforceActions: 'observed',
  useProxies: IEdetector() ? 'never' : 'always'
});

export interface SeoData {
  url: string;
  siteH1: string;
  bottomText: string;
}

class Store {
  data: SeoData = {
    url: '',
    siteH1: '',
    bottomText: ''
  };

  constructor() {
    makeObservable(this, {
      data: observable,
      setData: action
    });
  }

  getValue(name: keyof SeoData): string | false {
    const currentUrl = location.pathname;

    if (currentUrl !== this.data.url) {
      return false; // Данные точно не для этого адреса
    }

    if (typeof this.data[name] === 'undefined' || !this.data[name]) {
      return false; // Данных нет
    }

    return this.data[name];
  }

  setData(data: SeoData): void {
    this.data = data;
  }
}

const seoStore = new Store();

export type SeoStoreType = typeof seoStore;
export default seoStore;
